import React, { useEffect } from "react";
// import { useParams } from "react-router-dom";
import TipLoader from "../../utils/TipLoader/TipLoader";
import Post from "../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../utils/config";

const AuthenticationIndexMeNow = ({ page }) => {
  const url =
    page === "indexme"
      ? "/indexme-get-token-using-code"
      : "/get-token-using-code";
  const queryParams = new URLSearchParams(window.location.search);
  const getTokenUsingCode = async (code, state) => {
    try {
      const response = await Post(getAPIUrlBM() + url, {
        code: code,
        state: state,
      });
      if (response.status === 200) {
        return true;
      }
    } catch (error) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    const code = queryParams.get("code");
    const state = queryParams.get("state");
    if (code) {
      getTokenUsingCode(code, state)
        .then((res) => {
          if (res) {
            window.close();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  return (
    <div>{<TipLoader key={"AuthencationInIndexMeNow"} product={page} />}</div>
  );
};

export default AuthenticationIndexMeNow;
